import { get, identity } from 'lodash';
import { Store } from 'redux';

import axios from 'src/app/axios';
import { logoutAsync } from './store/authStore';
import { isAuthenticated } from './store/authSelectors';

export const setupInterceptors = (store: Store): void => {
  axios.interceptors.response.use(identity, error => {
    if (get(error, 'response.status') === 401 && isAuthenticated(store.getState())) {
      store.dispatch(logoutAsync());
      return Promise.reject(new Error('Session is expired'));
    }
    return Promise.reject(error);
  });
};
